export default {
  model: {},
  props: {},
  data() {
    return {
      screenWidth: "",
      screenHeight: "",
      isMobile: "",
      scrolltop: 0
    };
  },
  computed: {
    // 过滤列表空数据，填充 ---
    filterRecordValue() {
      return val => {
        if (val === 0 || val === "0") return 0;
        return val || "---";
      };
    },
    // 处理不能访问的图片
    filterCoverImg() {
      return val => {
        if (val.indexOf(",") == -1) {
          return "https://images.weserv.nl/?url=" + val;
        } else {
          return "https://images.weserv.nl/?url=" + val.split(",")[0];
        }
      };
    },
  },
  created() {
    if (process.env.VUE_ENV !== "server") {
      this.browserRedirect();
    }
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    this.screenHeight = document.body.clientHeight;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
      })();
    };
  },
  watch: {
    screenWidth() {
      if (this.screenWidth <= 820) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      console.log(this.isMobile);
    }
  },
  methods: {
    // file为上传的图片，可获取图片原始宽高
    getImgWideHigh(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = e => {
          let data = e.target.result;
          let img = new Image();
          img.src = data;
          img.onload = () => {
            resolve({ width: img.width, height: img.height });
            console.log("width", img.width);
            console.log("height", img.height);
          };
        };
        reader.readAsDataURL(file);
      });
    },
    // 判断字符类型
    CharMode(iN) {
      if (iN >= 48 && iN <= 57) {
        //数字
        return 1;
      }
      if (iN >= 65 && iN <= 90) {
        //大写字母
        return 2;
      }
      if (iN >= 97 && iN <= 122) {
        //小写
        return 4;
      } else {
        return 8;
      } //特殊字符
    },
    // 统计字符类型
    bitTotal(num) {
      var modes = 0;
      for (let i = 0; i < 4; i++) {
        if (num & 1) modes++;
        num >>>= 1;
      }
      return modes;
    },
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      console.log(sUserAgent);
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    scollTop(anchorScoll) {
      console.log(this.$route.path);
      if (this.$route.path != "/") {
        this.$router.push({
          path: "/"
        });
        setTimeout(() => {
          let scollHeight = document.getElementById(anchorScoll.anchor)
            .offsetTop;
          this.pulleyRoll(scollHeight, this.scrolltop);
        }, 2000);
      } else {
        let scollHeight = document.getElementById(anchorScoll.anchor).offsetTop;
        this.pulleyRoll(scollHeight, this.scrolltop);
      }
    },
    /**
     * 滑轮 向上滚动和向下滚动的函数
     * top是楼层距窗体顶部的距离,distance当前滚动条与窗体顶部的距离
     * */
    pulleyRoll(top, distance) {
      var small_interval = 0;
      var i = 0;
      var timer = null;
      /*向下滚动*/
      if (distance < top) {
        small_interval = (top - distance) / 50;
        timer = setInterval(() => {
          i++;
          distance += small_interval;
          document.documentElement.scrollTop = distance;
          if (i == 50) {
            clearInterval(timer);
          }
        }, 10);
      } else if (distance > top) {
        /*向上滚动*/
        small_interval = (distance - top) / 50;
        timer = setInterval(() => {
          i++;
          distance -= small_interval;
          document.documentElement.scrollTop = distance;
          if (i == 50) {
            clearInterval(timer);
          }
        }, 10);
      }
    },
    /**
     * 滑轮滚动事件 返回滑轮距顶部的距离
     * */
    getPulleyTopDistance() {
      var that = this;
      window.onscroll = function() {
        that.scrolltop =
          document.documentElement.scrollTop || document.body.scrollTop;
      };
    },
    pageTop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};



// WEBPACK FOOTER //
// src/util/mixin.js